import { render, staticRenderFns } from "./Form1ProcessHeader.vue?vue&type=template&id=318d83e4&scoped=true"
import script from "./Form1ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form1ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form1ProcessHeader.vue?vue&type=style&index=0&id=318d83e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d83e4",
  null
  
)

export default component.exports